<!-- @format -->
<div #container>
   <div #toolbar>
      <div class="toolbar__container" *ngIf="selectedStylesSubject$ | async as selectedStylesSubject">
         <div class="btn-group" role="group" aria-label="...">
            <button
               type="button"
               class="btn btn-default"
               tooltip="Apply bold text"
               (click)="onBold()"
               [disabled]="isDisable"
               [ngClass]="{ active: isBold }"
            >
               <i class="fa fa-bold" aria-hidden="true"></i>
            </button>
            <button
               type="button"
               class="btn btn-default"
               tooltip="Apply underline text"
               (click)="onUnderline()"
               [disabled]="isDisable"
               [ngClass]="{ active: isUnderline }"
            >
               <i class="fa fa-underline" aria-hidden="true"></i>
            </button>
            <button
               type="button"
               class="btn btn-default"
               tooltip="Reset styles/changes"
               (click)="resetChanges()"
               [disabled]="isDisable"
               *ngIf="false"
            >
               <i class="fa fa-eraser" aria-hidden="true"></i>
            </button>
         </div>
         <!--    FONT FAMILY SELECTION-->
         <p-dropdown
            #ddFont
            [options]="fontSource"
            [(ngModel)]="selectedFont"
            optionLabel="name"
            (onChange)="onFontChanges('FONT_FAMILY')"
            [disabled]="isDisable"
            styleClass="font-family__dropdown"
         >
            <ng-template let-item pTemplate="selectedItem">
               <span [style]="getFontStyleByName(item.value?.value)">
                  {{ item.label }}
               </span>
            </ng-template>
            <ng-template let-item pTemplate="item">
               <span [style]="getFontStyleByName(item.value?.value)">
                  {{ item.label }}
               </span>
            </ng-template>
         </p-dropdown>
         <!--      FONT SIZE SELECTION-->
         <ng-template [featureFlags]="['communication:editor:fontsize:tmp']">
            <p-dropdown
               [options]="fontSize"
               [(ngModel)]="selectedFontSize"
               optionLabel="name"
               (onChange)="onFontChanges('FONT_SIZE')"
               [disabled]="isDisable"
               styleClass="font-size__dropdown"
            >
               <ng-template let-item pTemplate="selectedItem">
                  <span [style]="getFontSizeByName(item.value?.value)">
                     {{ item.label }}
                  </span>
               </ng-template>
               <ng-template let-item pTemplate="item">
                  <span [style]="getFontSizeByName(item.value?.value)">
                     {{ item.label }}
                  </span>
               </ng-template>
            </p-dropdown>
         </ng-template>
         <!--     FONT COLOR SELECTION-->
         <ng-template [featureFlags]="['communication:editor:fontcolor:tmp']">
            <font-color-button
               [disable]="isDisable"
               [pickedColor]="pickedColor"
               [selectedColor]="selectedFontColor"
               (onFontColorChange)="onFontColorChange($event)"
            ></font-color-button>
         </ng-template>
         <!--      ALIGNMENTS SELECTION-->
         <div class="btn-group" role="group" aria-label="...">
            <button
               type="button"
               class="btn btn-default z-index-1"
               [disabled]="isDisable"
               (click)="onAlignmentChange('LEFT')"
               [ngClass]="{ active: textAlignment === 'left' }"
            >
               <i class="fa fa-align-left" aria-hidden="true"></i>
            </button>
            <button
               type="button"
               class="btn btn-default z-index-1"
               [disabled]="isDisable"
               (click)="onAlignmentChange('CENTER')"
               [ngClass]="{ active: textAlignment === 'center' }"
            >
               <i class="fa fa-align-center" aria-hidden="true"></i>
            </button>
            <button
               type="button"
               class="btn btn-default z-index-1"
               [disabled]="isDisable"
               (click)="onAlignmentChange('RIGHT')"
               [ngClass]="{ active: textAlignment === 'right' }"
            >
               <i class="fa fa-align-right" aria-hidden="true"></i>
            </button>
         </div>
         <!-- ADD HYPERLINK BUTTON SELECTION-->
         <div class="btn-group" role="group" (click)="onAddLink()">
            <button type="button" class="btn btn-default" [disabled]="isDisable">
               <i class="fa fa-link" aria-hidden="true"></i>
            </button>
         </div>
         <!--      UNDO / REDO CHANGES -->
         <div class="btn-group right-justified" role="group" aria-label="...">
            <button
               type="button"
               class="btn btn-default"
               tooltip="Undo changes"
               (click)="undoChanges()"
               [disabled]="!(canUndo$ | async) || isDisable"
            >
               <i class="fa fa-reply" aria-hidden="true"></i>
            </button>
            <button
               type="button"
               class="btn btn-default"
               tooltip="Redo changes"
               (click)="redoChanges()"
               [disabled]="!(canRedo$ | async) || isDisable"
            >
               <i class="fa fa-share" aria-hidden="true"></i>
            </button>
         </div>
      </div>
   </div>
   <div #content class="editor__body" id="editor__body">
      <ng-content></ng-content>
   </div>
</div>
